import React, { useEffect, useState } from "react";
import CardQR from "../components/Card/CardQR";
import ModalQR from "../components/Modal/ModalGenerateQR";
import ModalLoading from "../components/ModalLoading";
import ModalInformation from "../components/Modal/ModalInformation";
import _ from "lodash";
import { useAuth } from "../components/auth/authContext";
import Button from "../components/Button/Button";
import { requestAuthGet, requestAuthPost } from "../api/authInstance";
import { toastNotify } from "../utils/Utils";
import withAuth from "../components/withAuth";
import Container from "../components/Container/Container";

const GenerateFragment = ({ allowed_permissions }) => {
  // data localstorage
  const [user] = useState(JSON.parse(localStorage.getItem("dompet_user")));
  const [dataOutletKartini] = useState(
    JSON.parse(localStorage.getItem("dompet_detail_outlet")),
  );
  const { userData } = useAuth();
  const [dataQr, setDataQr] = useState([]);
  //   modal
  const [showModalLoading, setShowModalLoading] = useState(false);
  const [showModalInformation, setShowModalInformation] = useState(false);
  const [modalInformation, setModalInformation] = useState({});

  // prepare modal
  const [inputQR, setInputQR] = useState({});
  const [showModalQR, setShowModalQR] = useState(false);
  const [modalQRDetails, setModalQRDetails] = useState({
    title: "Add QR",
    type: "Add",
  });

  useEffect(() => {
    if (userData?.outlet?.retailer?.id) {
      GetDataQR();
    }
  }, [userData]);

  const GetDataQR = async () => {
    setShowModalLoading(true);
    try {
      const { data } = await requestAuthGet(`dynamic-link`, {
        params: { retailer: userData?.outlet?.retailer?.id ?? "" },
      });
      var pages = [];
      for (let i = 0; i < Math.ceil((data.length - 1) / 10); i++) {
        pages.push(i + 1);
      }
      setDataQr(data.data);
    } catch (error) {
      console.error(error);
    } finally {
      setShowModalLoading(false);
    }
  };

  const AddQR = async () => {
    setShowModalLoading(true);

    let payload = {
      ...inputQR,
      dynamicLinkType: "ae7542b4-37a5-4e33-b2af-3a711a30371b",
    };
    try {
      const dynamicQRData = await requestAuthGet("dynamic-link", {
        params: { project: inputQR.project, userOutlet: inputQR.userOutlet },
      });

      if (_.isEmpty(dynamicQRData.data.data)) {
        await requestAuthPost("dynamic-link", payload)
          .then((res) => {
            if (res.error) {
              toastNotify(res.errorMessage ?? "Failed to add QR", "error");
              setModalQRDetails({});
              setInputQR({});
            }
            GetDataQR();
            setModalQRDetails({});
            setInputQR({});
          })
          .catch((err) => {
            toastNotify(
              err?.response?.data?.message ?? "Failed to add QR",
              "error",
            );
          });
      } else {
        setShowModalInformation(true);
        setModalInformation({
          type: "error",
          title: "Data already exists",
          detail:
            "Data Already Exists: The information you are trying to submit already exists in our records",
        });
      }
    } catch (error) {
      console.error(error);
      setShowModalInformation(true);
      setModalQRDetails({});
      setInputQR({});
      setModalInformation({
        type: "error",
        title: "Unknown Error Occurred",
        detail:
          "We're sorry, but an unexpected error occurred, and we couldn't process your request. Our team has been notified of this issue. Please try again later or contact support if the problem persists. Thank you for your understanding.",
      });
    }
    setShowModalQR(false);
    setModalQRDetails({});
    setInputQR({});
    setShowModalLoading(false);
  };
  const EditQR = () => {};

  return (
    <>
      <ModalLoading
        showModal={showModalLoading}
        setShowModal={setShowModalLoading}
      />
      <ModalInformation
        showModal={showModalInformation}
        setShowModal={setShowModalInformation}
        type={modalInformation.type ?? ""}
        title={modalInformation.title ?? ""}
        detail={modalInformation.detail ?? ""}
      />
      <ModalQR
        modalQRDetails={modalQRDetails}
        showModal={showModalQR}
        setShowModal={setShowModalQR}
        inputQR={inputQR}
        setInputQR={setInputQR}
        functionAdd={AddQR}
        functionEdit={EditQR}
        userData={userData}
        dataOutletKartini={dataOutletKartini}
      />
      <Container>
        <div className="space-y-5">
          <div className="flex items-center justify-between">
            <h2 className="font-medium text-gray-700">QR List</h2>
            {allowed_permissions?.includes("Add") && (
              <Button
                label={`Generate QR`}
                variant="gradient"
                withIcon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="h-4 w-4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 3.75 9.375v-4.5ZM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 0 1-1.125-1.125v-4.5ZM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 13.5 9.375v-4.5Z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6.75 6.75h.75v.75h-.75v-.75ZM6.75 16.5h.75v.75h-.75v-.75ZM16.5 6.75h.75v.75h-.75v-.75ZM13.5 13.5h.75v.75h-.75v-.75ZM13.5 19.5h.75v.75h-.75v-.75ZM19.5 13.5h.75v.75h-.75v-.75ZM19.5 19.5h.75v.75h-.75v-.75ZM16.5 16.5h.75v.75h-.75v-.75Z"
                    />
                  </svg>
                }
                onClick={(e) => {
                  setShowModalQR(true);
                  setInputQR({});
                  setModalQRDetails({
                    title: "Add QR",
                    type: "Add",
                  });
                }}
              />
            )}
          </div>
          <div className=" mt-4 ">
            <div className="space-y-4">
              {dataQr.map((detail, i) => {
                return (
                  <CardQR
                    key={i}
                    data={detail}
                    enActionEdit={user.user_type === "member"}
                    enActionDelete={user.user_type === "member"}
                    isDisable={false}

                    // editFunction={ShowEditModal}
                    // deleteFunction={ShowDeleteModal}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default withAuth(GenerateFragment);
